<template lang="pug">
div
  v-card(flat)
    v-card-title Event Publicity
    keep-alive
      validation-observer(ref="o06" v-slot="{ invalid }" :persist="true" vid="o06")
        v-container          
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Is this a public or private event?
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_Public" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in publicOrPrivate",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Public === 'Private'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 The date, time and location of your event will appear on the County calendar, with the title of &quot;Private Event&quot;.
          v-row(v-if="SEA_Public === 'Public'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Do you want this event listed in the County calendar?
              v-radio-group(v-model="SEA_Publicized" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          div.d-flex.align-center(v-if="SEA_Publicized === 'Yes'")
            p.pb-0.body-1 Description for the public <a target="_blank" href="https://today.arlingtonva.us/">County calendar</a>&nbsp;&nbsp;&nbsp;
              v-icon mdi-open-in-new
          v-row(v-if="SEA_Public === 'Public'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12" v-if="SEA_Publicized === 'Yes'")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_CalendarDescription" :disabled="disabled" )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Is the event free or paid?
              p.pb-0.pl-8.text--secondary If the event has free and paid components (e.g. admission is free but food is available for purchase), select "Free" and describe below.
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_FreeOrPaid" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in freeOrPaid",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 What fees, if any, are associated with the event?
              v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_EventFee" :disabled="disabled")
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Topic(s)
              p.pb-0.pl-8.text--secondary Select one or more topics that will help the public find this event in the County calendar.
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-select(
                  v-model="SEA_Topics"
                  :items="calendarTopics"
                  attach
                  chips
                  :disabled="disabled"
                  multiple)
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Is this a family friendly event?
              v-radio-group(v-model="SEA_IsThisaFamilyFriendly" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Minimum Age (Years)
              p.pb-0.pl-8.text--secondary Leave blank if there is no minimum age for attendees.
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(
                rules="integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_MinimumAge" :disabled="disabled")
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Maximum Age (Years)
              p.pb-0.pl-8.text--secondary Leave blank if there is no maximum age for attendees.
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(
                rules="integer",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_MaximumAge" :disabled="disabled")
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Contact Person for Public Inquiries: First Name
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_PublicContactNameFirst" :disabled="disabled")
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Contact Person for Public Inquiries: Last Name
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_PublicContactNameLast" :disabled="disabled")
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Contact Person for Public Inquiries: Email
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="email", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_PublicContactEmail" :disabled="disabled")
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Contact Person for Public Inquiries: Contact Phone
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(
                :rules="{ regex: /[0-9]{3}-[0-9]{3}-[0-9]{4}/ }",
                v-slot="{ errors }"
                immediate
              )
                v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_PublicContactPhone" :disabled="disabled")
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row(v-if="SEA_Publicized === 'Yes'")
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.pb-0.body-1 Event Website URL
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_Website" :disabled="disabled")
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
      calendarTopics: (state) => state.calendarTopics,
    }),
    ...mapFields([
      "data.SEA_Public",
      "data.SEA_Publicized",
      "data.SEA_CalendarDescription",
      "data.SEA_FreeOrPaid",
      "data.SEA_EventFee",
      "data.SEA_Topics",
      "data.SEA_IsThisaFamilyFriendly",
      "data.SEA_MinimumAge",
      "data.SEA_MaximumAge",
      "data.SEA_PublicContactNameFirst",
      "data.SEA_PublicContactNameLast",
      "data.SEA_PublicContactEmail",
      "data.SEA_PublicContactPhone",
      "data.SEA_Website",
      "data.disabled",
    ]),
  },
  data: () => ({
    publicOrPrivate: ["Public", "Private"],
    freeOrPaid: ["Free", "Paid"],
  }),
  methods: {
    //
  },
};
</script>